import BagHandleOutline from 'virtual:icons/ion/bag-handle-outline';
import Heart from 'virtual:icons/lucide/heart';
import CircleHelp from 'virtual:icons/lucide/circle-help';
import Info from 'virtual:icons/lucide/info';
import RoundPhoneAndroid from 'virtual:icons/ic/round-phone-android';
import UserRoundPen from 'virtual:icons/lucide/user-round-pen';
import Home from 'virtual:icons/lucide/home';
import SquareLibrary from 'virtual:icons/lucide/square-library';
import WalletCards from 'virtual:icons/lucide/wallet-cards';
import BaselineRedeem from 'virtual:icons/ic/baseline-redeem';
import { PUBLIC_SITE_NAME } from '$env/static/public';

const bookMenuItems = [
	{
		label: 'Kategori',
		identifier: 'category'
	},
	{
		label: 'Semua Buku',
		identifier: 'all-books'
	},
	{
		label: 'Buku Gratis',
		identifier: 'free-books'
	},
	{
		label: 'Akan Terbit',
		identifier: 'coming-soon'
	},
	{
		label: 'Bundle Premium',
		identifier: 'bundles'
	}
] as const;

const getMenuItems = (params: { isOnHome: boolean; isLoggedIn: boolean }) => {
	const mainMenuItems = [
		[
			{
				label: 'Kembali ke Beranda',
				path: '/',
				icon: Home,
				isActive: !params.isOnHome
			},
			{
				label: 'Perpustakaan Saya',
				path: '/my-library',
				icon: SquareLibrary,
				isActive: true
			},
			{
				label: 'Histori Transaksi',
				path: '/transactions',
				icon: WalletCards,
				isActive: params.isLoggedIn
			},
			{
				label: 'Buku Favorit',
				path: '/favorites',
				icon: Heart,
				isActive: true
			},
			{
				label: 'Keranjang',
				path: '/cart',
				icon: BagHandleOutline,
				isActive: true
			}
		],
		[
			{
				label: 'Redeem',
				url: '/redeem',
				icon: BaselineRedeem,
				isActive: true
			},
			{
				label: 'Jadi Penulis',
				path: '/be-writer',
				icon: UserRoundPen,
				isActive: true
			},
			{
				label: 'Download Aplikasi',
				path: '/download-app',
				icon: RoundPhoneAndroid,
				isActive: true
			},
			{
				label: `Tentang ${PUBLIC_SITE_NAME}`,
				path: '/about',
				icon: Info,
				isActive: true
			},
			{
				label: 'Bantuan',
				path: '/help',
				icon: CircleHelp,
				isActive: true
			}
		]
	];

	return mainMenuItems;
};

export { bookMenuItems, getMenuItems };
